<template>
  <div class="home-container">
    <main>
      <div class="header">
        <span v-on:click="gotoHome">
          <span class="header1">BITMAX&nbsp;</span>
          <span class="header2">마음의소리</span>
        </span>
        <router-link to="/create" class="float-right"
          ><img src="../../../src/assets/images/create.png" class="header-icon"
        /></router-link>
      </div>
      <div class="tab">
        <input id="newAc" type="radio" name="tabs" checked />
        <label for="newAc">새 글</label>
        <input id="waitingAc" type="radio" name="tabs" />
        <label for="waitingAc">답변 대기</label>
        <section id="content1">
          <list-component :articleList="newArticleList" type="new"></list-component>
        </section>
        <section id="content2">
          <div v-if="Object.keys(waitingArticleList).length === 0" class="article-none">
            등록된 답변 대기 글이 없습니다.
          </div>
          <list-component :articleList="waitingArticleList" type="waiting"></list-component>
        </section>
      </div>
    </main>
  </div>
</template>

<script>
import firebase from 'firebase/app';
import List from '../list/List';

export default {
  name: 'Home',
  components: {
    'list-component': List,
  },
  data() {
    return {
      newArticleList: [],
      waitingArticleList: [],
    };
  },
  computed: {},
  mounted() {
    // this.getIpClient();
    this.getNewArticleList();
    this.getWaitingArticleList();
  },
  methods: {
    gotoHome() {
      this.$router.push({ name: 'Home' });
    },
    getNewArticleList() {
      firebase
        .database()
        .ref('article')
        .on('value', snapshot => {
          this.newArticleList = [];
          snapshot.forEach(childSnapshot => {
            var childData = childSnapshot.val();
            var id = childSnapshot.key;
            childData.id = id;
            var comment = childSnapshot.val().comment; //댓글리스트
            var commentCount = 0; //댓글갯수
            if (comment) {
              commentCount = Object.keys(comment).length;
              var comment_list = Object.values(comment);
              var commentContent = [];
              if (commentCount === 1) {
                commentContent.push(comment_list[0].content);
              } else {
                for (var i = commentCount - 2; i < commentCount; i++) commentContent.push(comment_list[i].content);
              }
            }
            var smallContent = ''; //더보기 기능
            var scCheck = 0;
            if (childData.content.length > 180) {
              smallContent = childData.content.substring(0, 180);
              scCheck = 1;
            }
            childData.smallContent = smallContent;
            childData.scCheck = scCheck;
            childData.commentCount = commentCount;
            childData.commentContent = commentContent;
            this.newArticleList.unshift(childData);
          });
        });
    },
    getWaitingArticleList() {
      firebase
        .database()
        .ref('article')
        .on('value', snapshot => {
          this.waitingArticleList = [];
          snapshot.forEach(childSnapshot => {
            var childData = childSnapshot.val();
            var comment = childSnapshot.val().comment;
            childData.comment = comment;
            var commentCount = 0;
            if (comment) {
              commentCount = Object.keys(comment).length;
              var comment_list = Object.values(comment);
              var commentContent = [];
              if (commentCount === 1) {
                commentContent.push(comment_list[0].content);
              } else {
                for (var i = commentCount - 2; i < commentCount; i++) commentContent.push(comment_list[i].content);
              }
            }
            childData.commentCount = commentCount;
            if (childData.like >= 110) {
              var id = childSnapshot.key;
              childData.id = id;
              var smallContent = ''; //더보기 기능
              var scCheck = 0;
              if (childData.content.length > 200) {
                smallContent = childData.content.substring(0, 200);
                scCheck = 1;
              }
              childData.smallContent = smallContent;
              childData.scCheck = scCheck;
              childData.commentContent = commentContent;
              childData.waiting = 1;
              this.waitingArticleList.unshift(childData);
            }
          });
        });
    },
    // async getIpClient() {
    //   try {
    //     const response = await axios.get('https://api.ipify.org?format=json');
    //     if (response.data.ip !== '121.134.136.28' && response.data.ip !== '125.131.77.43') {
    //       await this.$router.push({ name: 'NotAccess' });
    //     }
    //   } catch (error) {
    //     console.error(error);
    //   }
    // },
  },
};
</script>

<style scoped>
@import 'Home.scss';
</style>
